<template>
  <div class="skill-select" v-if="skillList.length">
    <span class="skill-select__title">优先技能</span>
    <Select v-model="selectedSkills" :multiple="multiple" clearable filterable :placeholder="placeholder" :loading="loading"
      @on-change="handleChange" style="width: 140px" >
      <Option v-for="item in skillList" :value="`${item.id}`" :key="item.id">
        {{ item.name }}
      </Option>
    </Select>
  </div>
</template>

<script>
import { getUserSkillListA } from '@/server/api'

export default {
  name: 'SkillSelect',
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 占位符文本
    placeholder: {
      type: String,
      default: '请选择技能'
    },
    // 默认选中的值
    value: {
      type: [String, Number, Array],
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      skillList: [],
      selectedSkills: this.value
    }
  },
  watch: {
    value: {
      handler(newVal) {
        console.log('newVal :>> ', newVal);
        this.selectedSkills = newVal
      },
      immediate: true
    }
  },
  mounted() {
    this.getSkillList()
  },
  methods: {
    // 获取技能列表
    async getSkillList() {
      try {
        this.loading = true
        const response = await getUserSkillListA()
        if (response.code !== 200) return
        this.skillList = response.data
      } catch (error) {
        this.$Message.error('获取技能列表失败')
        console.error('获取技能列表错误:', error)
      } finally {
        this.loading = false
      }
    },
    // 选择变化时触发
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('on-change', value)
    }
  }
}
</script>

<style scoped>
.skill-select {
  display: inline-block;
}
.skill-select__title {
  margin-right: 5px;
}
</style>